import { useState } from 'react';
import axios from 'axios';
import { API_STATUS } from '../utils/constants';
import { getApiHeaders } from '../utils/header-util';
import { toastWarn } from '../utils/toasts';

export function useFetch() {
   const [fetchResponseData, setFetchResponseData] = useState(null);
   const [fetchStatus, setFetchStatus] = useState(API_STATUS.IN_PROGRESS);

   const fetchData = async (payload, url) => {
      try {
         const response = await axios.post(url, payload, {
            headers: getApiHeaders(),
         });

         if (response.status !== 200) {
            toastWarn(response.data.message);
            setFetchResponseData([]);
            setFetchStatus(API_STATUS.FAILED);
         } else {
            setFetchResponseData(response?.data);
            setFetchStatus(API_STATUS.SUCCESS);
         }
      } catch (error) {
         console.warn('Error in Fetch records', error);
         setFetchResponseData([]);
         setFetchStatus(API_STATUS.FAILED);
         toastWarn(error.message);
      }
   };

   return { fetchResponseData, fetchStatus, fetchData };
}
